<template>
    <div class="registered">
        <!-- 头部 -->
        <div class="registered-top">
            <img src="../../assets/img/login/logo-h.png" alt="" />
            <p @click="toLogin">首页</p>
        </div>
        <!-- 注册主体 -->
        <div class="registered-body">
            <div class="registered-con">
                <!-- 注册表单 -->
                <div class="registered-form">
                    <h2>绑定维护大师通行证</h2>
                    <!-- 输入框组合 -->
                    <div class="form-group">
                        <input
                            type="text"
                            class="form-input"
                            ref="inp"
                            v-model="form.passportName"
                            placeholder="请输入通行证账号"
                            @focus="focusInput(1)"
                            @blur="blurInput(1)"
                        />
                    </div>
                    <div class="form-group">
                        <input
                            type="password"
                            class="form-input"
                            ref="inp2"
                            v-model="form.passportPassword"
                            maxlength="16"
                            placeholder="请输入你的登录密码"
                            @focus="focusInput(2)"
                            @blur="blurInput(2)"
                        />
                    </div>
                    <div class="form-group" style="display:flex">
                        <input
                            type="text"
                            class="form-inputcode"
                            v-model="form.passportCode"
                            placeholder="请输入验证码"
                        />
                        <button
                            class="form-buttoncode"
                            v-show="show"
                            @click="getSmsCode"
                        >
                            获取验证码
                        </button>
                        <button class="form-buttoncode" v-show="!show">
                            {{ count }} s
                        </button>
                    </div>
                    <div class="register-wrong" v-text="wrongText"></div>
                    <div class="form-group">
                        <button class="form-button" @click.prevent="handlSbmit">
                            绑定
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <div class="registered-footer">
            &reg; 2014-2019 杭州云智互联科技有限公司
        </div>
    </div>
</template>

<script>
import { sendWxBindSmsCode } from '@/requests/user';
import { loginWx } from '@/requests/user';
import { mapActions } from 'vuex';
// import { mapActions,mapState } from 'vuex'
// import FadeDownModal from '_c/modals/fadeDown'

export default {
  name: 'register',
  components: {
    // FadeDownModal
  },
  data() {
    return {
      captcha: '',
      show: true, // 显示倒计时
      count: '',
      timer: null,
      codeModel: false,
      codeWrong: '',
      wrongText: '',
      form: {
        passportName: '',
        passportPassword: '',
        passportCode: '',
        wxhash: ''
      }
    };
  },
  methods: {
    ...mapActions(['user/actionSetStatement']),
    // 刷新验证码
    editCaptcha() {
      this.captcha = '?' + Math.random();
    },
    // 关闭验证码弹框
    closeModel() {
      this.codeModel = false;
    },
    // 显示验证码弹框
    async getSmsCode() {
      let nameRe = this.$validateCenter.passportNameWhds(
        this.form.passportName
      );
      if (nameRe.res == false) {
        this.wrongText = nameRe.msg;
        return false;
      }
      let passwordRe = this.$validateCenter.passwordWhds(
        this.form.passportPassword
      );
      if (passwordRe.res == false) {
        this.wrongText = passwordRe.msg;
        return false;
      }
      let obj = {
        passportName: this.form.passportName,
        password: this.form.passportPassword
      };
      let res = await sendWxBindSmsCode(obj);
      if (res.code == 200) {
        this.wrongText = res.msg;
        this.countDown();
      } else {
        this.wrongText = res.msg;
      }
    },
    // 验证码倒计时
    countDown() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    // 注册
    async handlSbmit() {
      let obj = {
        passportName: this.form.passportName,
        passportPassword: this.form.passportPassword,
        smsCode: this.form.passportCode,
        wxhash: this.form.wxhash
      };
      let res = await loginWx(obj);
      if (res.code == 200) {
        this.toLogin();
      } else {
        this.wrongText = res.msg;
      }
    },
    // 边框聚焦变色
    focusInput(index) {
      if (index == 1) {
        this.$refs.inp.style.border = '1px solid #00c2de';
      } else if (index == 2) {
        this.$refs.inp2.style.border = '1px solid #00c2de';
      }
    },
    // 失去焦点恢复颜色
    blurInput(index) {
      if (index == 1) {
        this.$refs.inp.style.border = '1px solid #dcdcdc';
      } else if (index == 2) {
        this.$refs.inp2.style.border = '1px solid #dcdcdc';
      }
    },
    // 去登录页
    toLogin() {
      this['user/actionSetStatement'](1);
      if (
        window.location.href.split('val=').length > 1 &&
                window.location.href.split('val=')[1] == '1'
      ) {
        this.$router.push({
          path: this.$PAGE_API.home.children.VIPInfo.path
        });
      } else if (
        window.location.href.split('val=').length > 1 &&
                window.location.href.split('val=')[1] == '2'
      ) {
        this.$router.push({
          path: this.$PAGE_API.home.path + '?val=2'
        });
      } else {
        this.$router.push({
          path: this.$PAGE_API.home.path
        });
      }
    },
    urlCode() {
      this.form.wxhash = this.$route.query.wxhash;
    }
  },
  mounted() {
    this.urlCode();
  }
};
</script>

<style lang="scss">
.registered {
    width: 100%;
    height: 100vh;
    min-height: 920px;
    background-color: #f5f5f6;
    background-size: cover;
    background-position: center;
    position: relative;
    // 头部
    .registered-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 60px;
        background-color: #f5f5f6;
        border-bottom: 1px solid #d7d8d9;
        img {
            margin-left: 30px;
            width: 124px;
            height: 30px;
        }
        p {
            margin-right: 20px;
            font-size: 15px;
            color: #383d41;
            font-weight: bold;
            cursor: pointer;
        }
        p:hover {
            color: #00c2de;
        }
    }
    // 注册主体
    .registered-body {
        display: flex;
        justify-content: center;
        width: 100%;
        background-size: 90% 100%;
        background-position: center bottom;
        .registered-con {
            display: flex;
            justify-content: center;
            margin-top: 80px;
            width: 1000px;
            height: 530px;
            background-color: #fff;
            // 注册表单
            .registered-form {
                width: 320px;
                h2 {
                    font-size: 30px;
                    color: #373d41;
                    font-weight: bold;
                    line-height: 100px;
                }
                .form-group {
                    width: 100%;
                    padding: 10px 0;
                    // 表单输入框
                    .form-input {
                        padding-left: 10px;
                        width: 96.5%;
                        height: 40px;
                        font-weight: bold;
                        border: 1px solid #dcdcdc;
                        color: #000;
                        outline: none;
                        transition: all 0.7s;
                    }
                    // 表单按钮
                    .form-button {
                        margin-top: 40px;
                        width: 100%;
                        height: 40px;
                        font-weight: bold;
                        border: none;
                        outline: none;
                        color: #fff;
                        background-color: #00c6de;
                    }
                    //验证码输入框
                    .form-inputcode {
                        padding-left: 10px;
                        width: 69%;
                        height: 40px;
                        border: 1px solid #00c6de;
                        color: #000;
                        font-weight: bold;
                        background-color: #ddf8fc;
                    }
                    // 验证码按钮
                    .form-buttoncode {
                        width: 29%;
                        height: 42px;
                        border: 1px solid #00c6de;
                        background-color: #ddf8fc;
                        border-left: none;
                        color: #20c6e0;
                        font-weight: bold;
                    }
                    // 手机号输入框
                    .form-inputphone {
                        padding-left: 10px;
                        width: 78%;
                        height: 40px;
                        border: 1px solid #dcdcdc;
                        color: #000;
                        font-weight: bold;
                    }
                    // 手机号前缀
                    .form-buttonphone {
                        width: 20%;
                        height: 42px;
                        border: 1px solid #dcdcdc;
                        border-right: none;
                        font-weight: bold;
                        color: #989aa0;
                    }
                    .register-wrong {
                        position: absolute;
                        transform: translate(325px, -41px);
                        padding-left: 10px;
                        line-height: 40px;
                        color: #f00;
                        font-size: 12px;
                    }
                }
            }
        }
    }
    // 底部
    .registered-footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 60px;
        background-color: #383d41;
        color: #84878c;
        text-align: center;
        line-height: 60px;
        font-size: 16px;
    }
}
.model-body {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 360px;
    height: 300px;
    background-color: #fff;
    h5 {
        // width: 100%;
        background: #363636;
        border-left: 8px solid #09f;
        line-height: 40px;
        color: #fff;
        text-align: left;
        padding-left: 13px;
        margin: 0;
    }
    span {
        position: absolute;
        top: 10px;
        right: 10px;
        color: #fff;
        font-size: 16px;
        cursor: pointer;
    }
    span:hover {
        color: #f00;
    }
    p {
        img {
            width: 180px;
            height: 50px;
            display: block;
            margin: 24px auto;
        }
        input {
            margin-top: 10px;
            height: 60px;
            width: 100%;
            padding: 0;
            border-radius: 0px;
            color: #333;
            font-size: 16px;
            line-height: 60px;
            border: 0px;
            border-bottom: 1px solid #a1a1a1;
            text-align: center;
        }
        button {
            width: 128px;
            margin: 0 auto;
            padding: 0;
            font-size: 18px;
            height: 40px;
            line-height: 40px;
            background: #09c;
            color: #fff;
            border: 0;
        }
    }
    .wrong {
        color: #f33;
        font-size: 14px;
        line-height: 28px;
        height: 28px;
        margin: 8px 0;
        text-align: center;
    }
}
.register-wrong {
    position: absolute;
    transform: translateX(-30%);
    width: 820px;
    line-height: 40px;
    text-align: center;
    color: #f00;
    font-size: 12px;
}
</style>
